module.exports = __webpack_public_path__ + "img/footer_logo.8b6223a6.png";